/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PhoneLoginVerifyRequest
 */
export interface PhoneLoginVerifyRequest {
    /**
     * 
     */
    phone: string;
    /**
     * 
     */
    code: string;
}

/**
 * Check if a given object implements the PhoneLoginVerifyRequest interface.
 */
export function instanceOfPhoneLoginVerifyRequest(value: object): value is PhoneLoginVerifyRequest {
    if (!('phone' in value) || value['phone'] === undefined) return false;
    if (!('code' in value) || value['code'] === undefined) return false;
    return true;
}

export function PhoneLoginVerifyRequestFromJSON(json: any): PhoneLoginVerifyRequest {
    return PhoneLoginVerifyRequestFromJSONTyped(json, false);
}

export function PhoneLoginVerifyRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PhoneLoginVerifyRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'phone': json['phone'],
        'code': json['code'],
    };
}

export function PhoneLoginVerifyRequestToJSON(json: any): PhoneLoginVerifyRequest {
    return PhoneLoginVerifyRequestToJSONTyped(json, false);
}

export function PhoneLoginVerifyRequestToJSONTyped(value?: PhoneLoginVerifyRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'phone': value['phone'],
        'code': value['code'],
    };
}

